var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayerEclipse({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.952 55.86C9.53826 50.0556 9.28163 44.0296 10.1968 38.126C11.1119 32.2224 13.1808 26.5569 16.2855 21.4529C19.3902 16.3489 23.4697 11.9064 28.2913 8.37905C33.1128 4.85167 38.5819 2.30852 44.3863 0.894778L45.5415 5.63762C40.36 6.89966 35.4777 9.16992 31.1735 12.3188C26.8694 15.4677 23.2276 19.4335 20.456 23.9898C17.6845 28.5461 15.8376 33.6037 15.0206 38.8738C14.2037 44.1439 14.4328 49.5233 15.6948 54.7048L10.952 55.86Z",
    fill: "#9E459A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayerEclipse);
export default __webpack_public_path__ + "static/media/playerEclipse.f374413c.svg";
export { ForwardRef as ReactComponent };